import { render, staticRenderFns } from "./OwnerPayoutTable.vue?vue&type=template&id=213a6b7c&"
import script from "./OwnerPayoutTable.vue?vue&type=script&lang=js&"
export * from "./OwnerPayoutTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports